import { useContextSelector } from 'use-context-selector';
import { IOBTShopFeaturesConfig } from 'obt-common/hooks/useOBTShopFeaturesForUserId';
import { ApiProviderContext } from '../FareListItinerariesApiProvider/Context';

export function useAirSearchResultsFeatures(): IOBTShopFeaturesConfig {
  return useContextSelector(ApiProviderContext, (state) => state.airSearchResultsFeatures);
}
